// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#plategi {\n    height: 100px;\n}\n\n#plategi-table {\n    min-height: 100px;\n    max-height: 100px;\n}\n\nform[name=\"$ctrl.plategi_form\"] fieldset {\n    border: 0px;\n}", ""]);
// Exports
module.exports = exports;
